import { Link } from "react-router-dom";
import { useEffect } from "react";
import './NotFound.styles.scss';

const NotFound = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="notfound-page">
            <div className="notfound-container">
                <div className="notfound-content">
                    <div className="error-code">404</div>
                    <h1 className="error-title">Página no encontrada</h1>
                    <p className="error-description">
                        Lo sentimos, la página que estás buscando no existe o ha sido movida.
                    </p>
                    <div className="error-actions">
                        <Link to="/" className="btn-primary">
                            <i className="ri-home-line"></i>
                            Volver al Inicio
                        </Link>
                        <Link to="/servicios" className="btn-secondary">
                            Ver Servicios
                        </Link>
                    </div>
                    
                    <div className="quick-links">
                        <h3>Enlaces útiles:</h3>
                        <div className="links-grid">
                            <Link to="/nosotros" className="quick-link">
                                <i className="ri-information-line"></i>
                                Nosotros
                            </Link>
                            <Link to="/usados" className="quick-link">
                                <i className="ri-car-line"></i>
                                Usados
                            </Link>
                            <Link to="/0km" className="quick-link">
                                <i className="ri-star-line"></i>
                                0KM
                            </Link>
                            <Link to="/motos" className="quick-link">
                                <i className="ri-motorcycle-line"></i>
                                Motos
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFound;